var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAbcJointTrustPlan = function SvgAbcJointTrustPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 424,
    height: 94,
    fill: "none",
    viewBox: "0 0 424 94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B5563",
    d: "M172 59.5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-16a2 2 0 0 1-2-2zM202 59.5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-16a2 2 0 0 1-2-2zM232 59.5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-16a2 2 0 0 1-2-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M212.5 42.5A3.5 3.5 0 0 0 216 46h22a4.5 4.5 0 0 1 4.5 4.5v7h-1v-7A3.5 3.5 0 0 0 238 47h-22a4.49 4.49 0 0 1-3.5-1.673V57.5h-1V45.327A4.49 4.49 0 0 1 208 47h-22a3.5 3.5 0 0 0-3.5 3.5v7h-1v-7A4.5 4.5 0 0 1 186 46h22a3.5 3.5 0 0 0 3.5-3.5v-15h1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B5563",
    d: "M220 24.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
  })));
};
export default SvgAbcJointTrustPlan;